import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer } from 'utils/redux-injectors';
import type { MonthlyTimelineState, TimelineViewMode } from './types';

export const initialState: MonthlyTimelineState = {
  timelineViewMode: 'quarterly',
  expandedMonths: [],
  timelineIconsVisible: true,
  itemExpandVersion: 0
};

const monthlyTimelineSlice = createSlice({
  name: 'monthlyTimeline',
  initialState,
  reducers: {
    setTimelineViewMode(state, action: PayloadAction<TimelineViewMode>) {
      state.timelineViewMode = action.payload;
    },
    setExpandedMonths(state, action: PayloadAction<string[]>) {
      state.expandedMonths = action.payload;
    },
    toggleMonthExpanded(state, action: PayloadAction<string>) {
      const monthKey = action.payload;
      if (state.expandedMonths.includes(monthKey)) {
        state.expandedMonths = state.expandedMonths.filter(
          key => key !== monthKey
        );
      } else {
        state.expandedMonths.push(monthKey);
      }
    },
    collapseAllMonths(state) {
      state.expandedMonths = [];
    },
    applyExpandedMonthsFromPrefs(state, action: PayloadAction<string[]>) {
      state.expandedMonths = action.payload;
    },
    setTimelineIconsVisible(state, action: PayloadAction<boolean>) {
      state.timelineIconsVisible = action.payload;
    },
    bumpItemExpandVersion(state) {
      state.itemExpandVersion += 1;
    }
  }
});

export const monthlyTimelineActions = monthlyTimelineSlice.actions;
export const monthlyTimelineReducer = monthlyTimelineSlice.reducer;

export const useMonthlyTimelineSlice = () => {
  useInjectReducer({
    key: monthlyTimelineSlice.name,
    reducer: monthlyTimelineSlice.reducer
  });
  return { actions: monthlyTimelineSlice.actions };
};
